import React, { useState } from 'react';
import { Tlearning } from '../../../type/learning';
import { MINIO } from '../../../data/data';
import { Link } from 'react-router-dom';
import DynamicFaIcon from '../../atoms/DynamicFaIcon';

interface LearningItemVerticalProps {
    learning: Tlearning
}

const LearningItemVertical = (props: LearningItemVerticalProps) => {
    const { learning } = props;
    const [imgError, setImgError] = useState(false);

    const hasThumbnail = !!learning.thumbnail && !imgError;

    return (
        <div className='flex flex-col rounded-md overflow-hidden max-w-[200px] border bg-white'>
            <Link
                to={`/admin/learning/${learning.slug}`}
                className='block'
            >
                {hasThumbnail ? (
                    <img
                        src={`${MINIO}/${learning.thumbnail}`}
                        alt={learning.name}
                        className='w-full aspect-square object-cover'
                        onError={() => setImgError(true)}
                    />
                ) : (
                    <div className='w-full aspect-square bg-gray-200 flex items-center justify-center'>
                        <DynamicFaIcon name={'FaImage'} />
                    </div>
                )}
                <div className='px-2 py-2'>
                    <p className='text-[12px] font-semibold line-clamp-2'>
                        {learning.name}
                    </p>
                </div>
            </Link>
        </div>
    );
};

export default LearningItemVertical;